import React from 'react';
import { Form } from 'semantic-ui-react';
import { Form as FinalForm } from 'react-final-form';
import TextInput from '../../../../FinalForm/TextInput';

const AddMember = ({ value, onComplete=()=>{} }) => {

	const onSubmit = ({ value }) => {
		onComplete && onComplete(value);
	};

	return (
		<FinalForm
			onSubmit={onSubmit}
			validate={validate}
			initialValues={{ value }}
			render={({ handleSubmit }) => (
				<Form onSubmit={handleSubmit}>
					<Form.Group widths='equal'>
						<TextInput
							name='value'
							placeholder="New Value"
							label="New Value"
							action
							actionText={'Change'}
							required
						/>
					</Form.Group>
					{/* <GraphQLError error={this.props.mutateError}>There was an issue</GraphQLError> */}
				</Form>
			)}
		/>
	)
};

function validate(values) {
	const errors = {};
	if(!values.value) {
		errors.value = 'Required Field';
	}
	return errors;
}

export default AddMember;